export var modalConfig = {
  'edit': {
    title: 'SFxAccountSettingsEditUserModalTitle',
    okText: 'SFxAccountSettingsSaveButtonText',
    contentTitle: 'SFxAccountSettingsEditUserModalTitle',
    isShowRest: true,
    disableOk: true
  },
  'detail': {
    title: 'SFxAccountSettingsUserDetailModalTitle',
    okText: 'SFxAccountSettingsEditUserButtonText',
    contentTitle: '',
    disableOk: false,
    isShowRest: false
  },
  'add': {
    title: 'SFxAccountSettingsAddUserModalTitle',
    okText: 'SFxAccountSettingsModalAddUserSaveButtonText',
    contentTitle: 'SFxAccountSettingsAddUserModalTitle',
    isShowRest: false,
    disableOk: true
  },
  'request': {
    title: 'SFxAccountSettingsModalRequestUsertitleText',
    okText: 'SFxAccountSettingsModalRequestUserSaveButtonTextText',
    contentTitle: 'Request to add users to HxGN SFx Platform',
    isShowRest: false,
    disableOk: true
  },
  'delete': {
    title: 'SFxAccountSettingsDeleteUserModalTitle',
    okText: 'SFxAccountSettingsDeleteUserModalSaveButtonText',
    contentTitle: 'SFxAccountSettingsDeleteUserModalTitle',
    isShowRest: false,
    disableOk: true
  }
};